import React from "react";
import { profile } from "../mock";
import { Github, Linkedin, Mail, ArrowUp } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-900 bg-[#09090b]">
      <div className="max-w-6xl mx-auto px-6 md:px-8 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2">
            <span className="h-6 w-6 rounded-md bg-[#5eead4] text-[#09090b] grid place-items-center font-bold display text-sm">
              A
            </span>
            <span className="mono text-sm text-zinc-400">
              azzam.<span className="text-[#5eead4]">ai</span>
            </span>
          </div>
          <p className="mt-3 text-sm text-zinc-500 max-w-md leading-relaxed">
            {profile.name} — AI Engineer crafting RAG, LLMs and intelligent
            systems.
          </p>
        </div>

        <div>
          <div className="mono text-xs text-zinc-500 uppercase tracking-[0.2em] mb-4">
            Connect
          </div>
          <div className="flex flex-col gap-2 text-sm">
            <a
              href={profile.socials.email}
              className="text-zinc-300 hover:text-[#5eead4] transition-colors inline-flex items-center gap-2 w-max"
            >
              <Mail size={14} /> {profile.email}
            </a>
            <a
              href={profile.socials.linkedin}
              target="_blank"
              rel="noreferrer"
              className="text-zinc-300 hover:text-[#5eead4] transition-colors inline-flex items-center gap-2 w-max"
            >
              <Linkedin size={14} /> linkedin.com/in/azzam-saud
            </a>
            <a
              href={profile.socials.github}
              target="_blank"
              rel="noreferrer"
              className="text-zinc-300 hover:text-[#5eead4] transition-colors inline-flex items-center gap-2 w-max"
            >
              <Github size={14} /> github.com/Azzam-Saud
            </a>
          </div>
        </div>

        <div className="md:text-right">
          <div className="mono text-xs text-zinc-500 uppercase tracking-[0.2em] mb-4">
            Top
          </div>
          <a
            href="#top"
            className="inline-flex items-center gap-2 mono text-sm text-zinc-300 hover:text-[#5eead4] transition-colors"
          >
            Back to top <ArrowUp size={14} />
          </a>
        </div>
      </div>

      <div className="border-t border-zinc-900">
        <div className="max-w-6xl mx-auto px-6 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="mono text-xs text-zinc-600">
            © {new Date().getFullYear()} {profile.name}. All rights reserved.
          </p>
          <p className="mono text-xs text-zinc-600">
            <span className="text-[#5eead4]">//</span> built with intent
          </p>
        </div>
      </div>
    </footer>
  );
}
